import * as React from 'react';
import {
    Backdrop,
    CircularProgress,
    Divider,
    Accordion,
    AccordionSummary,
    Typography,
    AccordionDetails,
    Radio
} from '@mui/material';
import {Delete, Edit, ExpandMore} from '@mui/icons-material';
import {useTranslation} from "react-i18next";
import {convertPrice, handleSetServicesLogo} from "../../assets/js/main";
import {useDispatch, useSelector} from "react-redux";
import {ThemeContext} from "../../App";
import SimpleMap from "../../components/SimpleMap";
import {setSelectedServicesFromMap} from "../../redux/singleOrder/services/actions";
import HandleFetchData from "../../plugin/HandleFetchData";
import {setListReview} from "../../redux/singleOrder/review/actions";


export default function Review(props) {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const selector = useSelector((st) => st)
    const {fetchData} = HandleFetchData()

    const [expanded, setExpanded] = React.useState(0);
    const [selectedLat, setSelectedLat] = React.useState(0)
    const [selectedLng, setSelectedLng] = React.useState(0)
    const [listAddressAgent, setListAddressAgent] = React.useState([]);
    const [listAddressPost, setListAddressPost] = React.useState([]);
    const listCoordinate = [...listAddressAgent, ...listAddressPost]

    React.useEffect(() => {
        if (!selector?.single_sender?.need) {
            handleAgentCities()
            handleCourierCities()
        }
    }, [])

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    }

    const handlerSplitDate = (e) => {
        return e?.split("|")
    }

    const handlerPaymentType = (e) => {
        switch (e) {
            case 'online':
                return `${t("singleOrder.packageInfo.t14")}`;
            case 'cod':
                return `${t("singleOrder.packageInfo.t15")}`;
            case 'amnito':
                return `${t("singleOrder.packageInfo.t16")}`;
            case 'free':
                return `${t("singleOrder.packageInfo.t17")}`;
            case 'pass':
                return `${t("singleOrder.packageInfo.t18")}`;
        }
    }

    const handleAgentCities = async () => {
        let fetch = await fetchData('locationservice', 'GET', '/LocationService/GetAgentByCity', '', "", {
            "cityId": Number(selector?.single_sender?.city_id)
        }, 'postex')
        setListAddressAgent(fetch || [])
    }

    const handleCourierCities = async (e) => {
        let fetch = await fetchData('locationservice', 'GET', '/LocationService/GetCourierLocationByCity', '', "", {
            // "courierCode": Number(selector?.single_sender?.city_id),
            "courierCode": selector?.single_services?.selectedService?.CourierCode,
            "cityCode": Number(selector?.single_sender?.city_id)
        }, 'postex')
        setListAddressPost(fetch || [])
    }

    const handleChangeAgentId = (item) => {
        let list = [...selector?.single_review?.listReview]
        list[0].selectedOfficeAddress = !selector?.single_sender?.need ? (item?.shopId ? "1" : "2") + "=" + String(item?.id) : ''
        dispatch(setListReview(list))
    }

    return (
        <>
            <div className="reviewPage">
                <div className="row">
                    <div className="col-12">
                        <div className="detailsBox">
                            <h4 className="titleSection">{t("singleOrder.review.t1")}</h4>
                            {
                                selector?.single_review?.listReview?.map((item, index) => {
                                    return (
                                        <Accordion key={index} expanded={expanded === index}
                                                   onChange={handleChange(index)}>
                                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header"
                                                              expandIcon={<ExpandMore/>}>
                                                {/*<Typography>{t("singleOrder.review.t2")} {index + 1}</Typography>*/}
                                                <Typography>{t("packing.t1")}</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="row">
                                                    <div className="col-6 col-md-4 col-lg-3">
                                                        <h6>{t("singleOrder.review.t3")}</h6>
                                                        <span>{item?.GoodsType || '-'}</span>
                                                    </div>
                                                    <div className="col-6 col-md-4 col-lg-3">
                                                        <h6>{t("singleOrder.review.t5")}</h6>
                                                        <span>{item?.ApproximateValue?.toLocaleString() || '-'} {t("singleOrder.review.t6")}</span>
                                                    </div>
                                                    <div className="col-6 col-md-4 col-lg-3">
                                                        <h6>{t("singleOrder.review.t7")}</h6>
                                                        <span>{item?.Weight?.toLocaleString() || '-'} {t("singleOrder.review.t8")}</span>
                                                    </div>
                                                    <div className="col-6 col-md-4 col-lg-3">
                                                        <h6>{t("singleOrder.review.t9")}</h6>
                                                        <span>{item?.CartonSizeName || '-'}</span>
                                                    </div>
                                                    {/*{*/}
                                                    {/*   item?.NeedCarton && <div className="col-6 col-lg-4">*/}
                                                    {/*     <h6>{t("singleOrder.review.t11")}</h6>*/}
                                                    {/*     <span>{item?.NeedCarton ? 'بله' : 'خیر'}</span>*/}
                                                    {/*   </div>*/}
                                                    {/*}*/}

                                                    <Divider/>
                                                    <div className="col-12">
                                                        <div className="_bodyPage">
                                                            <div className="row">
                                                                <div className="col-12 col-lg-6">
                                                                    <h4 className="titleSection">{t("singleOrder.review.t12")}</h4>
                                                                    <div className="userInfo">
                                                                        <div className="userName">
                                                                            <h6>{(item?.Reciver_FristName || '-') + ' ' + (item?.Reciver_LastName || '-')}</h6>
                                                                        </div>
                                                                        <div className="phoneNumber">
                                                                            <h6>{item?.Reciver_mobile || '-'}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className="location">
                                                                        <h6>{item?.Reciver_Address || '-'}</h6>
                                                                    </div>
                                                                    <Divider className="d-block d-lg-none"/>
                                                                </div>
                                                                <div className="col-12 col-lg-6">
                                                                    <div className="serviceType">
                                                                        <h4 className="titleSection">{t("singleOrder.review.t13")}</h4>
                                                                        <div className="service">
                                                                            <div className="infoService">
                                                                                <img
                                                                                    src={handleSetServicesLogo(item?.SLA?.ServiceName)}
                                                                                    alt={item?.SLA?.ServiceName}
                                                                                    loading="lazy"/>
                                                                                <p>{item?.SLA?.ServiceName}</p>
                                                                            </div>
                                                                            <div className="timeService">
                                                                                <p>{t("singleOrder.review.t14")} : {handlerSplitDate(item?.SLA?.SLA)?.[0]}</p>
                                                                                {/*<p> {t("singleOrder.review.t15")} : {convertPrice(item?.SLA?.Price)} {t("singleOrder.review.t6")} | {handlerPaymentType(item?.paymentType)}</p>*/}
                                                                                <p>{handlerPaymentType(item?.paymentType)}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <Divider className="d-block d-lg-none"/>
                                                                </div>
                                                            </div>
                                                            {/*<Divider/>*/}

                                                            {/*{*/}
                                                            {/*  props?.item?.shipmentsData?.length &&*/}
                                                            {/*  <>*/}
                                                            {/*    <div className="infoPrice">*/}
                                                            {/*      <div className="row">*/}
                                                            {/*        <div className="col-12 col-md-6 col-lg-4">*/}
                                                            {/*          <div className="price">*/}
                                                            {/*            <p>{t("singleOrder.review.t16")}</p>*/}
                                                            {/*            <p>45،122 {t("singleOrder.review.t6")}</p>*/}
                                                            {/*          </div>*/}
                                                            {/*        </div>*/}
                                                            {/*        <div className="col-12 col-md-6 col-lg-4">*/}
                                                            {/*          <div className="price">*/}
                                                            {/*            <p>{t("singleOrder.review.t17")}</p>*/}
                                                            {/*            <p>16،122 {t("singleOrder.review.t6")}</p>*/}
                                                            {/*          </div>*/}
                                                            {/*        </div>*/}
                                                            {/*        <div className="col-12 col-md-6 col-lg-4">*/}
                                                            {/*          <div className="price">*/}
                                                            {/*            <p>{t("singleOrder.review.t18")}</p>*/}
                                                            {/*            <p>16،122 {t("singleOrder.review.t6")}</p>*/}
                                                            {/*          </div>*/}
                                                            {/*        </div>*/}
                                                            {/*        <div className="col-12 col-md-6 col-lg-4">*/}
                                                            {/*          <div className="price">*/}
                                                            {/*            <p>{t("singleOrder.review.t19")}</p>*/}
                                                            {/*            <p>164،122 {t("singleOrder.review.t6")}</p>*/}
                                                            {/*          </div>*/}
                                                            {/*        </div>*/}
                                                            {/*        <div className="col-12 col-md-6 col-lg-4">*/}
                                                            {/*          <div className="price">*/}
                                                            {/*            <p>{t("singleOrder.review.t20")}</p>*/}
                                                            {/*            <p>164،122 {t("singleOrder.review.t6")}</p>*/}
                                                            {/*          </div>*/}
                                                            {/*        </div>*/}
                                                            {/*        <div className="col-12 col-md-6 col-lg-4">*/}
                                                            {/*          <div className="price">*/}
                                                            {/*            <p>{t("singleOrder.review.t21")}</p>*/}
                                                            {/*            <p>164،122 {t("singleOrder.review.t6")}</p>*/}
                                                            {/*          </div>*/}
                                                            {/*        </div>*/}
                                                            {/*      </div>*/}
                                                            {/*    </div>*/}
                                                            {/*  </>*/}
                                                            {/*}*/}

                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="action">
                                                            <button type="button"
                                                                    onClick={() => props.handlerDeleteFromListReview(index)}
                                                                    id="deleteFromListReview">
                                                                <Delete/>
                                                            </button>
                                                            <button type="button"
                                                                    onClick={() => props.handlerEditItemListReview({
                                                                        index: index,
                                                                        ServiceID: item?.ServiceID
                                                                    })} id="editItemListReview">
                                                                <Edit/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="col-12"
                         style={!selector?.single_sender?.need ? {height: 'auto'} : {height: 0, overflow: 'hidden'}}>
                        <div className="map mt-2 mb-4">
                            <h5 className="mb-4">{t("singleOrder.serviceType.t16")}</h5>

                            {selector?.single_services?.selectedServicesFromMap?.address &&
                                <p className="mb-3">{t("singleOrder.serviceType.t28")}: {selector?.single_services?.selectedServicesFromMap?.address || '' + '  ' + selector?.single_services?.selectedServicesFromMap?.shopName || selector?.single_services?.selectedServicesFromMap?.name || ''}</p>
                            }


                            <div className="map-container">
                                <SimpleMap
                                    handlerAddressFromMap={(event) => console.log(event)}
                                    handlerLngFromMap={(event) => setSelectedLat(event)}
                                    handlerLatFromMap={(event) => setSelectedLng(event)}
                                    lngToMap={selector?.single_services?.selectedServicesFromMap?.pointY || selector?.single_sender?.lng}
                                    latToMap={selector?.single_services?.selectedServicesFromMap?.pointX || selector?.single_sender?.lat}
                                    coordinates={listCoordinate || []}
                                    showSearchInMap={false}
                                    zoom={selector?.single_services?.selectedServicesFromMap?.id ? 14 : 10}
                                    agent
                                />

                                <div className="list-address-map">
                                    <div className="d-none d-md-block">
                                        <h6 className="mb-2">{t("singleOrder.serviceType.t21")}</h6>
                                        <span>{t("singleOrder.serviceType.t22")}</span>

                                        <Divider/>
                                    </div>

                                    <span>{t("singleOrder.serviceType.t24")}:</span>

                                    <div className="list-shop">
                                        <ul>
                                            {
                                                listCoordinate?.map((item, index) => <li key={index}
                                                                                         className={selector?.single_services?.selectedServicesFromMap?.id === item.id ? 'active' : ''}
                                                >
                                                    <div className="icon">
                                                        <Radio
                                                            checked={selector?.single_services?.selectedServicesFromMap?.id === item.id}
                                                            onChange={() => {
                                                                dispatch(setSelectedServicesFromMap(item))
                                                                handleChangeAgentId(item)
                                                            }}
                                                            name="radio-buttons"
                                                        />
                                                    </div>
                                                    <button type="button"
                                                            onClick={() => {
                                                                dispatch(setSelectedServicesFromMap(item))
                                                                handleChangeAgentId(item)
                                                            }}>
                                                        {item?.address} - {item?.agentId ? '(' + selector?.single_review?.listReview[0]?.SLA?.ServiceName + ')' : t("singleOrder.serviceType.t31")}
                                                    </button>
                                                </li>)
                                            }
                                        </ul>
                                    </div>

                                </div>

                                {
                                    !listCoordinate?.length &&
                                    <div className="not-point">
                                        <p>{t("singleOrder.serviceType.t25")}</p>
                                    </div>
                                }

                            </div>

                        </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-4 mb-2">
                        <label>{t("singleOrder.invoice.t33")}</label>
                        <input type="text" autoComplete="on"
                               value={props.discountCode} id="discountCode"
                               onChange={e => props.handleDiscountCode(e.target.value)}/>
                    </div>
                    <div className="col-12 mb-2">
                        <h6>{t("singleOrder.review.t23")}</h6>
                    </div>
                </div>
            </div>

        </>
    )
}
